<template>
  <v-layout row justify-center align-start wrap class="mt-4 pt-2">
    <v-flex xs12 sm12 md6 lg6 xl6 class="mt-4">
      <h2 class="mb-4 pl-4">Experience (ShortV)</h2>
      <v-card-text class="py-0">
        <v-timeline align-top dense>

          <v-timeline-item color="blue" small>
            <v-layout pt-3>
              <v-flex xs4>
                <div class="caption font-weight-bold blue--text">Mar 2024 -</div>
                <div class="caption font-weight-bold blue--text">Present</div>
              </v-flex>
              <v-flex class="pl-2">
                <strong>CEO | Software Engineer (Nearshore) | IT Consultant</strong>
                <div class="caption mb-2">Silva's Software Consulting Services Inc..</div>
              </v-flex>
            </v-layout>
          </v-timeline-item>

          <v-timeline-item color="blue" small>
            <v-layout pt-3>
              <v-flex xs4>
                <div class="caption font-weight-bold blue--text">Aug 2021 -</div>
                <div class="caption font-weight-bold blue--text">Mar 2024</div>
              </v-flex>
              <v-flex class="pl-2">
                <strong>Remote PHP Developer</strong>
                <div class="caption mb-2">Simply PHP Inc.</div>
              </v-flex>
            </v-layout>
          </v-timeline-item>

          <v-timeline-item color="blue" small>
            <v-layout pt-3>
              <v-flex xs4>
                <div class="caption font-weight-bold blue--text">Nov 2019 -</div>
                <div class="caption font-weight-bold blue--text">Aug 2021</div>
              </v-flex>
              <v-flex class="pl-2">
                <strong>Technical lead / PHP Senior Web Developer</strong>
                <div class="caption mb-2">Travel Guardian Insurance INC. </div>
              </v-flex>
            </v-layout>
          </v-timeline-item>

          <v-timeline-item color="blue" small>
            <v-layout pt-3>
              <v-flex xs4>
                <div class="caption font-weight-bold blue--text">Apr 2013 -</div>
                <div class="caption font-weight-bold blue--text">Aug 2019</div>
              </v-flex>
              <v-flex class="pl-2">
                <strong>.Net Software Engineer </strong>
                <div class="caption mb-2">Colombia</div>
              </v-flex>
            </v-layout>
          </v-timeline-item>
        </v-timeline>
      </v-card-text>
    </v-flex>
    <v-flex id="education" xs12 sm12 md6 lg6 xl6 class="mt-4">
      <h2 class="mb-4 pl-4">Education</h2>
      <v-card-text class="py-0">
        <v-timeline align-top dense>

          <v-timeline-item color="blue" small>
            <v-layout pt-3>
              <v-flex xs4>
                <div class="caption font-weight-bold blue--text">Sep 2026 -</div>
                <div class="caption font-weight-bold blue--text">Sep 2026</div>
              </v-flex>
              <v-flex class="pl-2">
                <strong>Certified C# Professional Developer</strong>
                <div class="caption mb-2">w3schools.com
                  <span><a href="https://verify.w3schools.com/1RE1EEYXR1"
                      target="_blank">Review</a></span>
                </div>
              </v-flex>
            </v-layout>
          </v-timeline-item>

          <v-timeline-item color="blue" small>
            <v-layout pt-3>
              <v-flex xs4>
                <div class="caption font-weight-bold blue--text">Jun 2025 -</div>
                <div class="caption font-weight-bold blue--text">Jun 2025</div>
              </v-flex>
              <v-flex class="pl-2">
                <strong>Certified React Professional Developer</strong>
                <div class="caption mb-2">w3schools.com
                  <span><a href="https://verify.w3schools.com/1Q2TJTN6XM"
                      target="_blank">Review</a></span>
                </div>
              </v-flex>
            </v-layout>
          </v-timeline-item>

          <v-timeline-item color="blue" small>
            <v-layout pt-3>
              <v-flex xs4>
                <div class="caption font-weight-bold blue--text">Jun 2021 -</div>
                <div class="caption font-weight-bold blue--text">Jun 2021</div>
              </v-flex>
              <v-flex class="pl-2">
                <strong>Senior Certified Laravel Developer</strong>
                <div class="caption mb-2">laravel.com
                  <span><a href="https://verifier.certificationforlaravel.org/c1752575-c0cf-4242-81f9-c7b04e298d55"
                      target="_blank">Review</a></span>
                </div>
              </v-flex>
            </v-layout>
          </v-timeline-item>

          <v-timeline-item color="blue" small>
            <v-layout pt-3>
              <v-flex xs4>
                <div class="caption font-weight-bold blue--text">Aug 2019 -</div>
                <div class="caption font-weight-bold blue--text">Apr 2021</div>
              </v-flex>
              <v-flex class="pl-2">
                <strong>Data Analyst for Business (Postgraduate Degree)</strong>
                <div class="caption mb-2">St Clair College (Canada)
                  <span><a href="https://www.stclaircollege.ca/search?keys=LUIS+SILVA" target="_blank">Review</a></span>
                </div>
              </v-flex>
            </v-layout>
          </v-timeline-item>

          <v-timeline-item color="blue" small>
            <v-layout pt-3>
              <v-flex xs4>
                <div class="caption font-weight-bold blue--text">Nov 2018 -</div>
                <div class="caption font-weight-bold blue--text">Jan 2019</div>
              </v-flex>
              <v-flex class="pl-2">
                <strong>Software Product Management (Specialization)</strong>
                <div class="caption mb-2">University of Alberta (Coursera)
                  <span><a
                      href="https://www.coursera.org/account/accomplishments/specialization/certificate/PEHUTP33SWUD"
                      target="_blank">Review</a></span>
                </div>
              </v-flex>
            </v-layout>
          </v-timeline-item>

          <v-timeline-item color="blue" small>
            <v-layout pt-3>
              <v-flex xs4>
                <div class="caption font-weight-bold blue--text">Jan 2010 -</div>
                <div class="caption font-weight-bold blue--text">April 2015</div>
              </v-flex>
              <v-flex class="pl-2">
                <strong>Software Engineer</strong>
                <div class="caption mb-2">University Popular Of Cesar (Colombia)
                  <span><a
                      href="https://tramites.copnia.gov.co/Copnia_Microsite/CertificateOfGoodStanding/CertificateOfGoodStanding?registerNumber=20255-304057"
                      target="_blank">Review</a></span>
                </div>
              </v-flex>
            </v-layout>
          </v-timeline-item>

          <v-timeline-item color="blue" small>
            <v-layout pt-3>
              <v-flex xs4>
                <div class="caption font-weight-bold blue--text">Jan 2008 -</div>
                <div class="caption font-weight-bold blue--text">Dec 2009</div>
              </v-flex>
              <v-flex class="pl-2">
                <strong>Sofware System Analyst</strong>
                <div class="caption mb-2">Systems Center Institute S.A.S (Colombia)</div>
              </v-flex>
            </v-layout>
          </v-timeline-item>
        </v-timeline>
      </v-card-text>
    </v-flex>
    <v-layout row justify-center align-center wrap class="mt-4 pt-2">

      <v-flex xs12 sm12 md3 lg3 xl3 class="mx-2 pt-3">
        <h2>
          <span>BackEnd</span>
          <span class="blue--text"> Skills</span>
        </h2>
        <br>
        <strong>C# / ASP.NET Core / REST API</strong>
        <v-progress-linear v-model="buffer5" :buffer-value="bufferValue" color="blue" height="16"></v-progress-linear>
        <strong>PHP / Laravel / WordPress</strong>
        <v-progress-linear v-model="buffer3" :buffer-value="bufferValue" color="blue" height="16"></v-progress-linear>
        <strong>Python /django/ML Models</strong>
        <v-progress-linear v-model="buffer0" :buffer-value="bufferValue" color="blue" height="16"></v-progress-linear>
        <strong>Node.js / REST API</strong>
        <v-progress-linear v-model="buffer6" :buffer-value="bufferValue" color="blue" height="16"></v-progress-linear>
        <strong>Unit testing</strong>
        <v-progress-linear v-model="buffer0" :buffer-value="bufferValue" color="blue" height="16"></v-progress-linear>
      </v-flex>

      <v-flex xs12 sm12 md3 lg3 xl3 class="mx-2 pt-3">
        <h2>
          <span>FrontEnd</span>
          <span class="blue--text"> Skills</span>
        </h2>
        <br>
        <strong>React / Redux</strong>
        <v-progress-linear v-model="buffer5" :buffer-value="bufferValue" color="blue" height="16"></v-progress-linear>
        <strong>Vue</strong>
        <v-progress-linear v-model="buffer0" :buffer-value="bufferValue" color="blue" height="16"></v-progress-linear>
        <strong>Angular</strong>
        <v-progress-linear v-model="buffer0" :buffer-value="bufferValue" color="blue" height="16"></v-progress-linear>

        <strong>Plain HTML/CSS</strong>
        <v-progress-linear v-model="buffer5" :buffer-value="bufferValue" color="blue" height="16"></v-progress-linear>
        <strong>Vanilla JavaScript</strong>
        <v-progress-linear v-model="buffer6" :buffer-value="bufferValue" color="blue" height="16"></v-progress-linear>
      </v-flex>



      <v-flex xs12 sm12 md3 lg3 xl3 class="mx-2 pt-3">
        <h2>
          <span>Soft</span>
          <span class="blue--text"> Skills</span>
        </h2>
        <br>
        <strong>Team Collaboration</strong>
        <v-progress-linear v-model="buffer5" :buffer-value="bufferValue" color="blue" height="16"></v-progress-linear>
        <strong>Adaptability</strong>
        <v-progress-linear v-model="buffer6" :buffer-value="bufferValue" color="blue" height="16"></v-progress-linear>
        <strong>Time Management</strong>
        <v-progress-linear v-model="buffer3" :buffer-value="bufferValue" color="blue" height="16"></v-progress-linear>
        <strong>Attention to Detail</strong>
        <v-progress-linear v-model="buffer5" :buffer-value="bufferValue" color="blue" height="16"></v-progress-linear>
        <strong title="Always making sure the big picture is captured before getting hands dirty!">Bussines Focus</strong>
        <v-progress-linear v-model="buffer3" :buffer-value="bufferValue" color="blue" height="16"></v-progress-linear>
      </v-flex>
      

      <div class="mt-4 pt-2">
        <v-btn href="https://www.linkedin.com/in/luis-silva-spm" target="_blank"
          rel="noopener noreferrer"
          color="blue" dark large>
          View LinkedIn Profile
          <v-icon right dark>fab fa-linkedin-in</v-icon>
        </v-btn>
      </div>
    </v-layout>
  </v-layout>
</template>

<script>
export default {
  metaInfo: {
    title: "Resume",
    titleTemplate: "%s ← IT Contractor | Silva's SCS Inc",
    meta: [
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      {
        name: "description",
        content:
          "Vue NUXT HTML CSS JavaScript Design Adobe XD Photoshop Coding Skills Resume Work Web Developer Front-End"
      },
      { charset: "utf-8" },
      { property: "og:title", content: "IT Contractor | Silva's SCS Inc" },
      { property: "og:site_name", content: "IT Contractor | Silva's SCS Inc" },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://silvassoftwareconsultingservices.com" },
      {
        property: "og:image",
        content: "/favicon_io/apple-touch-icon.png"
      },
      {
        property: "og:description",
        content:
          "Vue NUXT HTML CSS JavaScript Design Adobe XD Photoshop Coding Skills Resume Work Web Developer Front-End"
      }
    ]
  },
  data() {
    return {
      value: 0,
      buffer1: 0,
      buffer2: 0,
      buffer3: 0,
      buffer4: 0,
      buffer5: 0,
      buffer6: 0,
      bufferValue: 100,
      interval: 0
    };
  },
  mounted() {
    this.startBuffer();
    this.scrollToHash();
  },
  watch: {
    "$route.hash"() {
      this.scrollToHash();
    }
  },

  beforeDestroy() {
    clearInterval(this.interval);
  },

  methods: {
    scrollToHash() {
      const hash = this.$route.hash;
      if (!hash) return;
      this.$nextTick(() => {
        setTimeout(() => {
          const el = document.querySelector(hash);
          if (el) {
            el.scrollIntoView({ behavior: "smooth", block: "start" });
          }
        }, 200);
      });
    },
    startBuffer() {
      this.interval = setInterval(() => {
        this.buffer0 = 40;
        this.buffer1 = 90;
        this.buffer2 = 85;
        this.buffer3 = 80;
        this.buffer4 = 80;
        this.buffer5 = 90;
        this.buffer6 = 70;
      }, 800);
    }
  }
};
</script>
<style></style>
